import React from 'react'
import { backgroundThemes } from '../../../constants/contentfulStyle.constant'
import ImgUtil from '../../../utils/img.utils'
import Button from '../button'
import Typography from '../typography'
import WrapperImage from '../wrapperImage'

const setLinkUrl = (link: any, uiPathUrl: any) => {
  if (link?.externalUrl) {
    return link.externalUrl
  } else if (link?.slug) {
    return uiPathUrl + link.slug
  } else if (link?.internalLink) {
    return uiPathUrl + link.internalLink.slug
  } else {
    return uiPathUrl
  }
}

export const ResourceHeader = ({ title }: any) => (
  <Typography type="header3" className="text ResourceLists__Title">
    {title}
  </Typography>
)

export const ResourceButton = ({ ctaLabelOverride, ctaList, theme, uiPathUrl }: any) => {
  const buttonText = ctaLabelOverride || ctaList?.text || ctaList?.pageName

  return (
    <div className="ResourceLists__ButtonWrapper">
      <Button
        className="ResourceLists__Button"
        type={'secondary'}
        theme={theme === backgroundThemes.DARK ? 'light' : 'dark'}
        href={setLinkUrl(ctaList, uiPathUrl)}
        text={buttonText}
      />
    </div>
  )
}

export const CategoryHeader = ({ titleOverride, name }: any) => (
  <Typography type="header5" className="text Category_Title">
    {titleOverride || name}
  </Typography>
)

export const CategoryIcon = ({ colorImage, whiteImage, isDarkTheme }: any) => {
  const logoUrl = colorImage?.image?.file?.url
  const whiteImg = whiteImage?.image?.file?.url
  const colorAltText = colorImage?.altText
  const whiteAltText = whiteImage?.altText
  const themeIcon = isDarkTheme ? whiteImg : logoUrl

  return (
    <WrapperImage
      src={ImgUtil.getResizedImageUrl(themeIcon, '')}
      width={40}
      height={30}
      alt={colorAltText || whiteAltText}
    />
  )
}

export const CategoryLink = ({ link, uiPathUrl }: any) => {
  const linkText = link.ctaText || link.text || link.h1Title || link.hero?.headline

  return (
    <Button
      key={link.id}
      className="Category__Link"
      type={'inline-text-link'}
      theme={'light'}
      href={setLinkUrl(link, uiPathUrl)}
      text={linkText}
    />
  )
}
